// Helper compartido: devuelve los sub-períodos (semanas Lun-Dom / quincenas /
// mes completo) que componen un mes calendario, según la frecuencia de pago
// del empleado. Se usa en:
//   - Planillas Mensuales (vista mensual)
//   - Aguinaldo (agrega brutos con overrides por sub-período)
//   - Liquidación (idem)
// Regla para "semanal": se incluye una semana Lun-Dom en el mes únicamente si
// su lunes cae dentro del mes, garantizando que una misma semana pertenezca a
// un único mes.

import { toLocalISO } from "./api";

export function subPeriodsForMonth(year, month, freq) {
  const first = new Date(year, month, 1);
  const last = new Date(year, month + 1, 0);
  const f = String(freq || "mensual").toLowerCase();
  const out = [];
  if (f === "semanal") {
    const startDay = first.getDay(); // 0=Dom
    const mondayOfFirstWeek = new Date(first);
    mondayOfFirstWeek.setDate(first.getDate() - ((startDay + 6) % 7));
    const cursor = new Date(mondayOfFirstWeek);
    while (cursor <= last) {
      if (cursor.getMonth() === month && cursor.getFullYear() === year) {
        const sunday = new Date(cursor);
        sunday.setDate(cursor.getDate() + 6);
        out.push({ start: toLocalISO(cursor), end: toLocalISO(sunday) });
      }
      cursor.setDate(cursor.getDate() + 7);
    }
    if (out.length === 0) {
      out.push({ start: toLocalISO(first), end: toLocalISO(last) });
    }
    return out;
  }
  if (f === "quincenal") {
    out.push({ start: toLocalISO(first), end: toLocalISO(new Date(year, month, 15)) });
    out.push({ start: toLocalISO(new Date(year, month, 16)), end: toLocalISO(last) });
    return out;
  }
  // mensual (default): un solo período
  return [{ start: toLocalISO(first), end: toLocalISO(last) }];
}

// Construye el "override" para computePayrollForEmployee a partir de un doc
// crudo de la colección planilla_overrides.
export function buildOverrideFromDoc(o) {
  if (!o) return null;
  return {
    ord: o.ord, ext: o.ext, feriado: o.feriado,
    dias_libres: o.dias_libres,
    dias_feriado: o.dias_feriado,
    dias_incapacidad_ccss: o.dias_incapacidad_ccss,
    dias_vacaciones: o.dias_vacaciones,
    dias_licencia: o.dias_licencia,
    ccss_override: o.ccss_override,
    rebajos_override: o.rebajos_override,
  };
}
